<template>
  <v-card class="mx-auto" outlined>
    <div id="inspire">
      <v-data-table
          :headers="headers"
          :items="admissionRuleItems"
          class="elevation-1"
          :items-per-page="10"
          :footer-props="footerProps"
          :hide-default-footer="admissionRuleItems.length <= 0"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="openDialog()">
              <v-icon left>mdi-plus</v-icon>
              {{ $t("ADD_NEW") }}
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="editItem(item)">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click="deleteItem(item)">
            <v-icon color="red">mdi-delete</v-icon>
          </v-btn>
          <v-btn icon @click="toggleActivation(item)">
            <v-icon color="green" v-if="item.isActive">mdi-toggle-switch</v-icon>
            <v-icon color="grey" v-else>mdi-toggle-switch-off</v-icon>
          </v-btn>
          <pr-confirmDialog ref="confirm"></pr-confirmDialog>
        </template>

        <template v-slot:no-data>
          <v-alert color="warning">{{ $t("NO_DATA") }}</v-alert>
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" max-width="800px">
        <v-card>
          <v-card-title>{{ formTitle }}</v-card-title>
          <v-card-text>

            <v-form ref="form" v-model="valid">
              <v-select
                  :disabled="!!editedItem.id"
                  v-model="editedItem.faculty"
                  :items="serverTranslateArray(faculties, 'name')"
                  item-text="name"
                  item-value="id"
                  :label="$t('FACULTY')"
                  required
                  outlined
              ></v-select>

              <v-select
                  v-model="editedItem.certificateType"
                  :items="serverTranslateArray(certificateTypes, 'name')"
                  item-text="name"
                  item-value="id"
                  :label="$t('ADMISSION_DATA.STEP2.CERTIFICATION')"
                  outlined
                  required
              ></v-select>
              <v-select
                  v-model="editedItem.majorTypes"
                  :items="serverTranslateArray(filteredMajors, 'name')"
                  multiple
                  item-text="name"
                  item-value="id"
                  :label="$t('ADMISSION_DATA.STEP2.MAJOR')"
                  required
                  outlined
              ></v-select>
              <v-switch v-model="editedItem.isActive"
                        :label="$t('IS_ACTIVE')">
              </v-switch>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="save">{{ $t("SAVE") }}</v-btn>
            <v-btn color="darken3" class="white--text" @click="close">{{ $t("CANCEL") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import serverTranslations from "@/mixins/serverTranslations";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import globalMethods from "@/mixins/globalMethods";

export default {
  name: "List",
  mixins: [serverTranslations, globalMethods],
  components: {
    "pr-confirmDialog": ConfirmDialog
  },
  data() {
    return {
      faculties: [],
      certificateTypes: [],
      certificateTypesMajors: [],
      admissionRuleItems: [],
      filteredMajors:[],
      headers: [
        {text: this.$t("FACULTY"), value: "facultyName"},
        {text: this.$t("ADMISSION_DATA.STEP2.CERTIFICATION"), value: "certificateName"},
        {text: this.$t("ADMISSION_DATA.STEP2.MAJOR"), value: "certificateMajorName"},
        {text: this.$t("ACADEMIC_YEAR"), value: "academicYearName"},
        {text: this.$t("SEMESTER"), value: "academicSemesterName"},
        {text: this.$t("ACTIONS"), value: "actions", sortable: false}
      ],
      footerProps: {
        showFirstLastPage: true,
        firstIcon: "mdi-arrow-collapse-left",
        lastIcon: "mdi-arrow-collapse-right",
        prevIcon: "mdi-arrow-left",
        nextIcon: "mdi-arrow-right",
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      },
      dialog: false,
      valid: true,
      editedItem: {},
      defaultItem: {faculty: "", certificateType: "", majorTypes: "",signatureUser:1, isActive: 1}
    };
  },
  computed: {
    formTitle() {
      return this.editedItem.id ? this.$t("EDIT") : this.$t("ADD_NEW");
    }
  },
  created() {
    this.fetchItems();
    this.$http.get("/api/general_data/faculties/").then(res => {
      this.faculties = res.data.data;
    })
    this.$http.get('/api/admission_rules/certificates/options/')
        .then(res => {
          this.certificateTypes = res.data.data.certificates;
          this.certificateTypesMajors = res.data.data.majors;
    });
  },
  watch:  {
  'editedItem.certificateType'(newCertId) {
    if (!newCertId) {
      this.filteredMajors = [];
      return;
    }
    this.filteredMajors = this.certificateTypesMajors.filter(major =>
      major.certificatesIds.includes(Number(newCertId))
    );
  }
},
  methods: {
    fetchItems() {
      this.$http.post("/api/admission_rules/admission-rules/",{'flag':1}).then(
          res => {
            this.admissionRuleItems = res.data.data || [];
          },
          err => {
            this.admissionRuleItems = [];
            this.showToasted("error", err.response?.data?.message || "Unknown error");
          }
      );
    },
    openDialog() {
      this.dialog = true;
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    save() {
      this.editedItem.signatureUser=1
      this.editedItem.isActive=(this.editedItem.isActive===false?0:1)
      this.editedItem.majorTypes=(this.editedItem.majorTypes.length>0?this.editedItem.majorTypes.join(','):'')
      if (this.editedItem.id) {
        this.$http.put(`/api/admission_rules/admission-rules/${this.editedItem.id}/update/`, this.editedItem)
            .then((res) => {
              this.showToasted("success",res.data.message);
              this.fetchItems();
              this.close();
        },
         err => {
              this.showToasted("error", err.response.data.message);
              this.fetchItems();
              this.close();

            });
      } else {
        this.$http.post("/api/admission_rules/admission-rules/create/", this.editedItem)
            .then((res) => {
              this.showToasted("success",res.data.message);
              this.close();
              this.fetchItems();
        },
          err => {
            this.showToasted("error", err.response.data.message);
            this.fetchItems();
            this.close();
          }
        );
      }
    },
    editItem(item) {
        this.editedItem.id=item.id;
        this.editedItem.faculty=item.faculty;
        this.editedItem.certificateType = Number(item.certificate_type);
        this.editedItem.majorTypes =  Array.isArray(item.major_types)? item.major_types: item.major_types?.split(',').map(id => Number(id)) || [];
        this.editedItem.isActive=item.is_active;
        this.filteredMajors = this.certificateTypesMajors.filter(major =>
          major.certificatesIds.includes(Number(this.editedItem.certificateType))
        );
        this.dialog = true;
    },
    deleteItem(item) {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "CONFIRM_MESSAGES.DELETE_CONFIRMATION")
          .then(res => {
            if (res) {
              this.$http.delete(`/api/admission_rules/admission-rules/${item.id}/delete/`)
                  .then(() => {
                    this.fetchItems();
                  });
            }
          })

    },
    toggleActivation(item) {
      const updated = {...item, isActive:(item.isActive===1?0:1)};
      this.$http.put(`/api/admission_rules/admission-rules/${item.id}/update/`, updated)
          .then(() => {
        this.fetchItems();
      },
      err => {
        this.showToasted("error", err.response.data.message);
        this.fetchItems();
      });
    }
  }
};
</script>
